import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzAddOnModule } from 'ng-zorro-antd/core';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { B2CSharedPipeModule } from 'b2c-ui/core';
import { ProductRankingBgIcon, B2cUiIconModule, B2CUiIconService } from 'b2c-ui-icon';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-ranking.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-zorro-antd/card';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ng-zorro-antd/core';
import * as ɵngcc4 from 'ng-zorro-antd/tabs';
import * as ɵngcc5 from 'ng-zorro-antd/tooltip';
import * as ɵngcc6 from 'b2c-ui-icon';
import * as ɵngcc7 from 'ng-zorro-antd';
import * as ɵngcc8 from 'b2c-ui/core';

function B2CProdcutRankingComponent_h4_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.title);
} }
const _c0 = function (a0, a1) { return { "mb-1": a0, "mb-3": a1 }; };
function B2CProdcutRankingComponent_h4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 5);
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_h4_2_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c0, (ctx_r0.lists == null ? null : ctx_r0.lists.length) > 1, (ctx_r0.lists == null ? null : ctx_r0.lists.length) == 1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r0.title);
} }
function B2CProdcutRankingComponent_div_3_ng_container_1_nz_tab_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { contentList: a0 }; };
function B2CProdcutRankingComponent_div_3_ng_container_1_nz_tab_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nz-tab", 10);
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_div_3_ng_container_1_nz_tab_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const list_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    const _r4 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("nzTitle", ctx_r8.tab[i_r10]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c1, list_r9));
} }
function B2CProdcutRankingComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "nz-tabset", 8);
    ɵngcc0.ɵɵtemplate(2, B2CProdcutRankingComponent_div_3_ng_container_1_nz_tab_2_Template, 2, 5, "nz-tab", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzType", "line")("nzSelectedIndex", ctx_r7.currentIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.lists);
} }
function B2CProdcutRankingComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_div_3_ng_container_1_Template, 3, 3, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.tab == null ? null : ctx_r1.tab.length) === (ctx_r1.lists == null ? null : ctx_r1.lists.length));
} }
function B2CProdcutRankingComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProdcutRankingComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CProdcutRankingComponent_ng_template_4_ng_container_0_Template, 1, 0, "ng-container", 11);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, ctx_r3.lists[0]));
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r20 = ɵngcc0.ɵɵreference(3);
    const _r22 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("nzTooltipTitle", _r20);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r22);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 19);
} if (rf & 2) {
    const item_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r15 == null ? null : item_r15.tooltipTemplate, ɵngcc0.ɵɵsanitizeHtml);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵpipe(1, "pnl");
    ɵngcc0.ɵɵelement(2, "i", 28);
    ɵngcc0.ɵɵpipe(3, "pnl");
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind2(1, 5, item_r15.value, "text") + " mt-1");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("nzType", ɵngcc0.ɵɵpipeBind2(3, 8, item_r15.value, "caret"))("nzTheme", "fill");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r15.value ? ɵngcc0.ɵɵpipeBind2(6, 11, item_r15 == null ? null : item_r15.value, "1.2-2") + "%" : "-");
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r31.listValuePrefix);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_div_2_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r30.listValuePrefix);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵpipe(1, "pnl");
    ɵngcc0.ɵɵtemplate(2, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_div_2_Template, 2, 1, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelement(4, "i", 28);
    ɵngcc0.ɵɵpipe(5, "pnl");
    ɵngcc0.ɵɵelementStart(6, "span");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "number");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpipeBind2(1, 6, item_r15.value, "text") + " text-right");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r28.listValuePrefix);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("nzType", ɵngcc0.ɵɵpipeBind2(5, 9, item_r15.value, "caret"))("nzTheme", "fill");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind2(8, 12, item_r15.value, "1.2-2"), "%");
} }
const _c2 = function (a0) { return { "pt-3": a0 }; };
const _c3 = function (a0) { return { "text-sm": a0 }; };
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "span", 22);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 23);
    ɵngcc0.ɵɵelementStart(5, "div", 24);
    ɵngcc0.ɵɵelementStart(6, "div", 25);
    ɵngcc0.ɵɵlistener("click", function B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r35); const item_r15 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.onNav(item_r15.urlParam); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_7_Template, 7, 14, "div", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_div_8_Template, 9, 15, "div", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵngcc0.ɵɵnextContext();
    const first_r18 = ctx_r36.first;
    const j_r16 = ctx_r36.index;
    const last_r17 = ctx_r36.last;
    const item_r15 = ctx_r36.$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c2, !first_r18));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(j_r16 + 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", last_r17 ? ctx_r23.indicator ? "border-bottom pb-3" : "" : "border-bottom pb-3");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c3, ctx_r23.horizontal));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", item_r15.name, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r23.horizontal);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r23.horizontal);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r37 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r37.indicator);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_6_ng_container_1_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzStringTemplateOutlet", ctx_r24.indicator);
} }
function B2CProdcutRankingComponent_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_1_Template, 2, 2, "div", 13);
    ɵngcc0.ɵɵtemplate(2, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_2_Template, 1, 1, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, B2CProdcutRankingComponent_ng_template_6_ng_container_0_ng_template_4_Template, 9, 11, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, B2CProdcutRankingComponent_ng_template_6_ng_container_0_div_6_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const _r22 = ɵngcc0.ɵɵreference(5);
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r15 == null ? null : item_r15.tooltipTemplate)("ngIfElse", _r22);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.indicator);
} }
function B2CProdcutRankingComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CProdcutRankingComponent_ng_template_6_ng_container_0_Template, 7, 3, "ng-container", 12);
} if (rf & 2) {
    const contentList_r13 = ctx.contentList;
    ɵngcc0.ɵɵproperty("ngForOf", contentList_r13);
} }
function ProductRankingListsInterface() { }
if (false) {
    /** @type {?} */
    ProductRankingListsInterface.prototype.name;
    /** @type {?} */
    ProductRankingListsInterface.prototype.value;
    /** @type {?|undefined} */
    ProductRankingListsInterface.prototype.urlParam;
    /** @type {?|undefined} */
    ProductRankingListsInterface.prototype.tooltipTemplate;
}
/**
 * ##### Import this component individually to your module
 * `import { B2CProductRankingModule } from 'b2c-ui/product-ranking';`
 */
class B2CProdcutRankingComponent {
    constructor() {
        this.currentIndex = 0;
        // TODO: Add change horizontal value as responsive flag
        this.horizontal = false;
        /**
         * Set tabs
         */
        this.tab = [];
        /**
         * Set lists
         */
        this.lists = [];
        /**
         * Callback function for user clicks on title
         */
        this.navigate = new EventEmitter();
    }
    /**
     * @param {?=} value
     * @return {?}
     */
    onNav(value = '') {
        this.navigate.emit(value);
    }
}
B2CProdcutRankingComponent.ɵfac = function B2CProdcutRankingComponent_Factory(t) { return new (t || B2CProdcutRankingComponent)(); };
B2CProdcutRankingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CProdcutRankingComponent, selectors: [["b2c-product-ranking"]], inputs: { tab: "tab", lists: "lists", title: "title", listValuePrefix: "listValuePrefix", indicator: "indicator" }, outputs: { navigate: "navigate" }, decls: 8, vars: 3, consts: [[1, "p-2"], ["class", "mb-1", 3, "ngClass", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["noTab", ""], ["content", ""], [1, "mb-1", 3, "ngClass"], [4, "nzStringTemplateOutlet"], [4, "ngIf"], [3, "nzType", "nzSelectedIndex"], [3, "nzTitle", 4, "ngFor", "ngForOf"], [3, "nzTitle"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngFor", "ngForOf"], ["nzTooltipPlacement", "bottomLeft", "nz-tooltip", "", 3, "nzTooltipTitle", 4, "ngIf", "ngIfElse"], ["tooltipTemplate", ""], ["containerTemplate", ""], ["class", "text-black-5 text-xs mt-2", 4, "ngIf"], ["nzTooltipPlacement", "bottomLeft", "nz-tooltip", "", 3, "nzTooltipTitle"], [4, "ngTemplateOutlet"], [3, "innerHTML"], [1, "d-flex", 3, "ngClass"], ["b2c-ui-icon", "", "name", "productRankingBgIcon", 1, "mr-3", "product-ranking-img"], [1, "text-lg", "font-weight-bold"], [1, "d-flex", "w-100", 3, "ngClass"], [3, "ngClass"], [1, "font-weight-bold", "pointer", 3, "innerHTML", "click"], [3, "class", 4, "ngIf"], ["style", "min-width: 80px;", 3, "class", 4, "ngIf"], ["nz-icon", "", 3, "nzType", "nzTheme"], [2, "min-width", "80px"], [1, "text-black-5", "text-xs", "mt-2"]], template: function B2CProdcutRankingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nz-card");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, B2CProdcutRankingComponent_h4_2_Template, 2, 5, "h4", 1);
        ɵngcc0.ɵɵtemplate(3, B2CProdcutRankingComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, B2CProdcutRankingComponent_ng_template_4_Template, 1, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, B2CProdcutRankingComponent_ng_template_6_Template, 1, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(5);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.lists == null ? null : ctx.lists.length) > 1)("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NzCardComponent, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.NzStringTemplateOutletDirective, ɵngcc4.NzTabSetComponent, ɵngcc2.NgForOf, ɵngcc4.NzTabComponent, ɵngcc2.NgTemplateOutlet, ɵngcc5.NzTooltipDirective, ɵngcc6.B2CIconDirective, ɵngcc7.NzIconDirective], pipes: [ɵngcc8.PnlPipe, ɵngcc2.DecimalPipe], styles: ["\n      .product-ranking-img {\n        height: 35px;\n        min-width: 35px;\n      }\n    "], encapsulation: 2, changeDetection: 0 });
B2CProdcutRankingComponent.propDecorators = {
    title: [{ type: Input }],
    tab: [{ type: Input }],
    listValuePrefix: [{ type: Input }],
    indicator: [{ type: Input }],
    lists: [{ type: Input }],
    navigate: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProdcutRankingComponent, [{
        type: Component,
        args: [{
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                selector: 'b2c-product-ranking',
                template: "<nz-card>\r\n  <div class=\"p-2\">\r\n    <h4 *ngIf=\"title\" class=\"mb-1\" [ngClass]=\"{'mb-1': lists?.length > 1, 'mb-3': lists?.length == 1}\">\r\n      <ng-container *nzStringTemplateOutlet=\"title\">{{ title }}</ng-container>\r\n    </h4>\r\n    <div *ngIf=\"lists?.length > 1 else noTab\">\r\n      <ng-container *ngIf=\"tab?.length === lists?.length\">\r\n        <nz-tabset [nzType]=\"'line'\" [nzSelectedIndex]=\"currentIndex\">\r\n          <nz-tab *ngFor=\"let list of lists; let i = index\" [nzTitle]=\"tab[i]\">\r\n            <ng-container *ngTemplateOutlet=\"content; context: {contentList: list}\"></ng-container>\r\n          </nz-tab>\r\n        </nz-tabset>\r\n      </ng-container>\r\n    </div>\r\n    <ng-template #noTab>\r\n      <ng-container *ngTemplateOutlet=\"content; context: {contentList: lists[0]}\"></ng-container>\r\n    </ng-template>\r\n    <ng-template #content let-contentList=\"contentList\">\r\n      <ng-container *ngFor=\"let item of contentList; let j = index let last = last;  let first = first\">\r\n        <div\r\n          nzTooltipPlacement=\"bottomLeft\" nz-tooltip [nzTooltipTitle]=\"tooltipTemplate\"\r\n          *ngIf=\"item?.tooltipTemplate; else containerTemplate\">\r\n          <ng-container *ngTemplateOutlet=\"containerTemplate\"></ng-container>\r\n        </div>\r\n\r\n        <ng-template #tooltipTemplate>\r\n          <span [innerHTML]=\"item?.tooltipTemplate\"></span>\r\n        </ng-template>\r\n\r\n        <ng-template #containerTemplate>\r\n          <div class=\"d-flex\" [ngClass]=\"{'pt-3': !first}\">\r\n            <div b2c-ui-icon name=\"productRankingBgIcon\" class=\"mr-3 product-ranking-img\">\r\n              <span class=\"text-lg font-weight-bold\">{{ j + 1 }}</span>\r\n            </div>\r\n            <div class=\"d-flex w-100\" [ngClass]=\"last? (indicator? 'border-bottom pb-3' : '') : 'border-bottom pb-3'\">\r\n              <div [ngClass]=\"{'text-sm': horizontal}\">\r\n                <div class=\"font-weight-bold pointer\" (click)=\"onNav(item.urlParam)\" [innerHTML]=\"item.name\"></div>\r\n                <div [class]=\"(item.value | pnl:'text') + ' mt-1'\" *ngIf=\"!horizontal\">\r\n                  <i nz-icon [nzType]=\"item.value | pnl:'caret'\" [nzTheme]=\"'fill'\"></i>\r\n                  <span>{{ item.value ? (item?.value | number:'1.2-2') + '%' : '-' }}</span>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"horizontal\" style=\"min-width: 80px;\" [class]=\"(item.value | pnl:'text') + ' text-right'\">\r\n                <div *ngIf=\"listValuePrefix\">\r\n                  <ng-container *nzStringTemplateOutlet=\"listValuePrefix\">{{ listValuePrefix }}</ng-container>\r\n                </div>\r\n                <div>\r\n                  <i nz-icon [nzType]=\"item.value | pnl:'caret'\" [nzTheme]=\"'fill'\"></i>\r\n                  <span>{{ item.value | number:'1.2-2' }}%</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n\r\n        <div class=\"text-black-5 text-xs mt-2\" *ngIf=\"indicator\">\r\n          <ng-container *nzStringTemplateOutlet=\"indicator\">{{ indicator }}</ng-container>\r\n        </div>\r\n      </ng-container>\r\n    </ng-template>\r\n  </div>\r\n</nz-card>\r\n",
                styles: [`
      .product-ranking-img {
        height: 35px;
        min-width: 35px;
      }
    `]
            }]
    }], function () { return []; }, { tab: [{
            type: Input
        }], lists: [{
            type: Input
        }], navigate: [{
            type: Output
        }], title: [{
            type: Input
        }], listValuePrefix: [{
            type: Input
        }], indicator: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    B2CProdcutRankingComponent.prototype.currentIndex;
    /** @type {?} */
    B2CProdcutRankingComponent.prototype.horizontal;
    /**
     * Set title
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.title;
    /**
     * Set tabs
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.tab;
    /**
     * Set list value prefix(for responsive display only)
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.listValuePrefix;
    /**
     * Set indicator
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.indicator;
    /**
     * Set lists
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.lists;
    /**
     * Callback function for user clicks on title
     * @type {?}
     */
    B2CProdcutRankingComponent.prototype.navigate;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-product-ranking.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const ICONS = [ProductRankingBgIcon];
class B2CProductRankingModule {
    /**
     * @param {?} b2cIconService
     */
    constructor(b2cIconService) {
        this.b2cIconService = b2cIconService;
        this.b2cIconService.registerIcons([...ICONS]);
    }
}
B2CProductRankingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CProductRankingModule });
B2CProductRankingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CProductRankingModule_Factory(t) { return new (t || B2CProductRankingModule)(ɵngcc0.ɵɵinject(ɵngcc6.B2CUiIconService)); }, imports: [[
            CommonModule,
            NzAddOnModule,
            NzCardModule,
            NzTabsModule,
            B2CNgzIconModule,
            B2CSharedPipeModule,
            B2cUiIconModule,
            NzToolTipModule
        ]] });
/** @nocollapse */
B2CProductRankingModule.ctorParameters = () => [
    { type: B2CUiIconService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CProductRankingModule, { declarations: function () { return [B2CProdcutRankingComponent]; }, imports: function () { return [CommonModule,
        NzAddOnModule,
        NzCardModule,
        NzTabsModule,
        B2CNgzIconModule,
        B2CSharedPipeModule,
        B2cUiIconModule,
        NzToolTipModule]; }, exports: function () { return [B2CProdcutRankingComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CProductRankingModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CProdcutRankingComponent],
                exports: [B2CProdcutRankingComponent],
                imports: [
                    CommonModule,
                    NzAddOnModule,
                    NzCardModule,
                    NzTabsModule,
                    B2CNgzIconModule,
                    B2CSharedPipeModule,
                    B2cUiIconModule,
                    NzToolTipModule
                ]
            }]
    }], function () { return [{ type: ɵngcc6.B2CUiIconService }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    B2CProductRankingModule.prototype.b2cIconService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-product-ranking.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CProdcutRankingComponent, B2CProductRankingModule };


//# sourceMappingURL=b2c-ui-product-ranking.js.map